// ----------------------------------------------------------------------------
// Orietation Widget
// ----------------------------------------------------------------------------

import vtkWidgetManager from '@kitware/vtk.js/Widgets/Core/WidgetManager';
import {
  createInteractiveOrientationMarkerWidget,
  alignCameraOnViewWidgetOrientationChange,
} from '@kitware/vtk.js/Widgets/Widgets3D/InteractiveOrientationWidget/helpers';


function vxVtkOrientationWidget (vtkModel) {
    const renderer =  vtkModel.renderer;
    const renderWindow = vtkModel.renderWindow;
    const render = renderWindow.render;
    const renderWindowInteractor = renderWindow.getInteractor();

    const camera = renderer.getActiveCamera();
    const widgetManager = vtkWidgetManager.newInstance();

    const { interactiveOrientationWidget, orientationMarkerWidget } =
        createInteractiveOrientationMarkerWidget(
            widgetManager,
            renderWindowInteractor,
            renderer
        );

    const vw = widgetManager.addWidget(interactiveOrientationWidget);

    const subscription = alignCameraOnViewWidgetOrientationChange(
        vw,
        camera,
        orientationMarkerWidget,
        widgetManager,
        render
    );

    return widgetManager;
}
export default vxVtkOrientationWidget;